import TextInput from './TextInput';
import './TextInput.css';

export default TextInput;



// WEBPACK FOOTER //
// ./src/shared/components/TextInput/index.js